import DynamicFormControl from './DynamicFormControl';

export { DynamicFormControl };
export default DynamicFormControl;
